import { Link } from "react-router-dom";

interface Props {
  language: "es" | "en";
}

/**
 * Author box reutilizable y discreto.
 * Solo hechos permitidos por VERIFIED-CLAIMS.md: rol, especialización y mercados.
 * Sin premios, títulos, certificaciones ni cifras (todos NEEDS_EVIDENCE).
 */
export const AuthorBox = ({ language }: Props) => {
  const t =
    language === "es"
      ? {
          label: "Sobre el autor",
          name: "Luis ROC",
          role: "Consultor de SEO y Search Growth",
          bio: "Más de 25 años de experiencia, trabajando en marketing digital desde el año 2000. Trabaja con empresas que compiten en Estados Unidos: entornos B2B, ecommerce y búsqueda bilingüe inglés/español. Su trabajo se centra en arquitectura de búsqueda, SEO técnico y demanda orgánica cualificada.",
          expertiseLabel: "Áreas de trabajo",
          expertise: ["SEO técnico", "SEO internacional", "Búsqueda bilingüe EN/ES", "Ecommerce y Amazon", "Visibilidad en AI Search"],
          links: [
            { label: "Perfil profesional", href: "/sobre-mi" },
            { label: "Metodología", href: "/metodologia" },
            { label: "Servicios", href: "/servicios" },
          ],
        }
      : {
          label: "About the author",
          name: "Luis ROC",
          role: "SEO and Search Growth consultant",
          bio: "25+ years of experience, working in digital marketing since 2000. Works with businesses competing in the United States, including B2B, ecommerce and bilingual English/Spanish search environments. His work focuses on search architecture, technical SEO and qualified organic demand.",
          expertiseLabel: "Areas of work",
          expertise: ["Technical SEO", "International SEO", "Bilingual EN/ES search", "Ecommerce and Amazon", "AI Search visibility"],
          links: [
            { label: "Professional profile", href: "/en/about" },
            { label: "Methodology", href: "/en/methodology" },
            { label: "Services", href: "/en/services" },
          ],
        };

  return (
    <aside className="mt-16 border-t border-border pt-8">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand">{t.label}</p>
      <h2 className="mt-3 text-lg font-semibold text-foreground">{t.name}</h2>
      <p className="text-sm text-muted-foreground">{t.role}</p>
      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted-foreground">{t.bio}</p>

      <p className="mt-5 text-xs font-semibold uppercase tracking-wide text-foreground">{t.expertiseLabel}</p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {t.expertise.map((e) => (
          <li key={e} className="rounded-full border border-border px-3 py-1 text-xs text-muted-foreground">
            {e}
          </li>
        ))}
      </ul>

      <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        {t.links.map((l) => (
          <li key={l.href}>
            <Link to={l.href} className="text-brand underline-offset-4 hover:underline">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};
